import styled from "styled-components";

export const StyledTransactionSettingsBoxContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;

  .info-text {
    color: #1c1726;
    font-size: 1.4rem;
  }
  .bold-text {
    color: #1c1726;
    font-size: 1.4rem;
    font-weight: 600;
  }
  .underline-text {
    text-decoration: underline;
  }
`;
